import { INPUT } from '@adalo/constants'

import getObjectsOfType from './getObjectsOfType'

const getInputObjects = objects => {
  return getObjectsOfType(objects, INPUT)
}

export default getInputObjects
